export default __webpack_public_path__ + "static/media/td.2f496833.svg";